import React, { useEffect } from "react";
import Navigation from "./Navigation";
import Banner from "./Banner";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";

function Pricing() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      const navigate = useNavigate()
  return (
    <div>
      <div className="banner-section-outer">
        <Navigation />
        <section className="sub-banner-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <div className="sub-banner-text">
                  <h1 className="text-white mb-lg-4 mb-3">Pricing</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section class="customer-base-section overflow-hidden">
        <div class="container">
          <div class="row">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2">
              <div
                class="customer-base-section-text position-relative wow bounceIn"
                data-wow-duration="2s"
              >
                <figure class="customer-base-section-shape-img-1 mb-0 position-absolute">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-shape-img-1.png"
                    alt=""
                  />
                </figure>
                <h2 class="mb-lg-4 mb-md-3 mb-2">
                NO LONG TERM CONTRACT
                </h2>
               
               
              
                    <div class="customer-base-section-listing-outer">
                      <ul class="customer-base-sectin-listing p-0 m-0">
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>No Set Up Fees
                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>All Calls Recorded

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Interactive Voice Response (IVR)

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Report Portal

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Recruiting/Hiring/Training

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Campaign Management

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Quality Assurance/Mystery Shoppers

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Call Center Hotline/Help Desk

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>All pricing subject to change

                        </li>
                        <li class="list-unstyled">
                          <i class="fal fa-check-circle"></i>Integration fee depends on POS

                        </li>
                      </ul>
                  
                 
                  <div class="col"></div>
                </div>
                <div class="customer-base-section-btn-outer">
                  <Link to={"/book-a-demo"}
                    class="d-inline-block position-relative hover-effect"
                    href="about.html"
                  >
                    Book a demo and get your quote
                    <i class="far fa-long-arrow-alt-right position-absolute"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 order-xl-2 order-lg-2 order-md-2 order-sm-1 order-1">
              <div
                class="customer-base-section-img-content position-relative wow slideInRight"
                data-wow-duration="2s"
              >
                <figure class="customer-base-section-shape-img-2 mb-0 position-absolute">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-shape-img-2.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-img-1 position-absolute mb-0">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-customer-img-1.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-img-2 position-absolute mb-0">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-customer-img-2.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-base-section-main-img mb-0 text-right position-relative">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-main-img.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-img-3 position-absolute mb-0">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-customer-img-3.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-img-4 position-absolute mb-0">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-customer-img-4.png"
                    alt=""
                  />
                </figure>
                <figure class="customer-img-5 position-absolute mb-0">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-customer-img-5.png"
                    alt=""
                  />
                </figure>
                <div class="counter-box position-absolute">
                  <figure class="plus-icon float-left mb-0">
                    <img
                      class="img-fluid"
                      src="assets/images/plus-icon.png"
                      alt=""
                    />
                  </figure>
                  <span class="number count d-inline-block">1281</span>
                  <span class="suffix d-inline-block">+</span>
                  <span class="customer d-block">New Customers</span>
                </div>
                <figure class="customer-base-section-shape-img-3 mb-0 position-absolute">
                  <img
                    class="img-fluid"
                    src="assets/images/customer-base-section-shape-img-3.png"
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="services-section position-relative">
    <div class="container">
       
            <div class="services-section-inner text-center position-relative">
                <h2 class="mb-lg-4 mb-md-3 mb-2 ">Can you put a value on?</h2>
              
                <figure class="services-section-shape-img-1 mb-0 position-absolute">
                    <img class="img-fluid" src="assets/images/services-section-shape-img-1.png" alt=""/>
                </figure>
           
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
                <div class="services-section-plan-box hover-effect">
                    <figure>
                        <img src="assets/images/services-section-plan-box-img-1.png" alt=""/>
                    </figure>
                    <h4 class="font-weight-bold">Excellent Customer Services</h4>
                    <p class="text-size-16">Which means Returning Customers & Stronger Brand Loyalty..</p>
                    <a class="d-inline-block text-decoration-none" href="services.html">Read More<i class="far fa-long-arrow-alt-right position-relative"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
                <div class="services-section-plan-box hover-effect">
                    <figure>
                        <img src="assets/images/services-section-plan-box-img-2.png" alt=""/>
                    </figure>
                    <h4 class="font-weight-bold">Better Utilization of Resources
</h4>
                    <p class="text-size-16">Which means that Make-Times are lower & more orders fulfilled.

</p>
                    <a class="d-inline-block text-decoration-none" href="services.html">Read More<i class="far fa-long-arrow-alt-right position-relative"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 text-md-left text-center">
                <div class="services-section-plan-box hover-effect">
                    <figure>
                        <img src="assets/images/services-section-plan-box-img-3.png" alt=""/>
                    </figure>
                    <h4 class="font-weight-bold">Improved Employee Morale
</h4>
                    <p class="text-size-16">Which means Workplace stress is lower & Improved Labor Turnover.

</p>
                    <a class="d-inline-block text-decoration-none" href="services.html">Read More<i class="far fa-long-arrow-alt-right position-relative"></i></a>
                </div>
            </div>
        </div>
        
        <figure class="services-section-shape-img-2 mb-0 position-absolute">
            <img class="img-fluid" src="assets/images/services-section-shape-img-2.png" alt=""/>
        </figure>
    </div>
</section>

      <Footer />
    </div>
  );
}

export default Pricing;
